import createNavigationLimiterLogger from "./navigation";
export default function createLimiterLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `limiter:${input.type}` });
    return {
        navigation: createNavigationLimiterLogger(log),
    };
}
